import React from 'react';

const TrustBadges = () => {
  return (
    <section className="py-16 border-y border-outline-variant bg-surface-container-lowest" data-testid="social-proof-stats">
      <div className="max-w-container-max mx-auto px-margin-desktop">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center" data-testid="stat-businesses">
            <div className="font-display-lg text-display-lg text-primary">1,000+</div>
            <div className="font-label-caps text-label-caps text-on-surface-variant mt-2">ACTIVE BUSINESSES</div>
          </div>
          <div className="text-center border-l border-outline-variant" data-testid="stat-sales">
            <div className="font-display-lg text-display-lg text-primary">&#x20B9;10Cr+</div>
            <div className="font-label-caps text-label-caps text-on-surface-variant mt-2">SALES TRACKED</div>
          </div>
          <div className="text-center border-l border-outline-variant" data-testid="stat-rating">
            <div className="font-display-lg text-display-lg text-primary">4.8</div>
            <div className="font-label-caps text-label-caps text-on-surface-variant mt-2">USER RATING</div>
          </div>
          <div className="text-center border-l border-outline-variant" data-testid="stat-ai">
            <div className="font-display-lg text-display-lg text-primary">24/7</div>
            <div className="font-label-caps text-label-caps text-on-surface-variant mt-2">AI ASSISTANCE</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
